import { get, put, del } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf';
import { identity } from 'lodash';

export const actions = {
  loadIntegration: get`reviews-integrations`(identity),
  saveIntegration: put`reviews-integrations`(identity),
  deleteIntegration: del`reviews-integrations`(),
};

export const reducer = createReducer(actions, {
  [actions.loadIntegration]: (s, { payload }) => ({
    ...s,
    integration: payload.integration,
  }),
  [actions.saveIntegration]: (s, { payload }) => ({
    ...s,
    integration: payload.integration,
  }),
  [actions.deleteIntegration]: (s) => ({
    ...s,
    integration: undefined,
  }),
});
